<template>
  <div class="page-wrap">
    <div class="experience">
      <div class="experience-title" :style="experienceTitle"></div>
      <div class="experience-content">
        <div class="experience-list">
          <div class="experience-item" v-for="(item, index) in list" :key="index">
            <a target="_blank" :href="item.url">{{item.text}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="experience-bg" :style="experienceBg"></div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      experienceTitle: `background: url(${process.env.BASE_URL}ImgFiles/home/gzty.png) no-repeat center/cover;`,
      experienceBg: `background: url(${process.env.BASE_URL}ImgFiles/home/gzjy1.jpg) no-repeat center/cover;`,
      list: [
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650627709&idx=1&sn=aef1d601923e0a0add53a1c0bc76a2ed&chksm=882e3e30bf59b7269dfbb10f90f0ffded10b77bac24461d096e435addf650a52fe06db682fea&token=557267957&lang=zh_CN#rd",
          text: "初入职场的第一年……他们过的怎么样？",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650627455&idx=1&sn=abb2340889a138ed58571249cd40d627&chksm=882e3d32bf59b424c7baeaaf5c1733e903ac7ea0f972f7d71f77c9c362940bf99922fb5b8487&token=557267957&lang=zh_CN#rd",
          text: "和公司谈5年以上的“恋爱”是种什么体验？",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650627277&idx=1&sn=e4a12c62f7e100599428ea0df6bc7085&chksm=882e3c80bf59b5964b83d023f701fdfec609137a41a9fd156c905ee7941cd6509e0ecfc97010&token=557267957&lang=zh_CN#rd",
          text: "细数这些年HR们收到的“表白”！",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650627221&idx=1&sn=fb0214480dd22b5f4498f75c58a0e16e&chksm=882e3cd8bf59b5ceff5befcba87295e1f94788df45038f9b89d3b6edc87e922f9128ea5ccef3&token=557267957&lang=zh_CN#rd",
          text: "当我从程序员变为项目经理后……",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650626942&idx=1&sn=19367eecd19d9a0315c9f4fd3c505d55&chksm=882e3b33bf59b22596f108187c4d0078ccb9908b8c26ddcee02fb94d38c32d5bcf22e63e5017&token=557267957&lang=zh_CN#rd",
          text: "职场高光时刻，你体验过吗？",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650626491&idx=1&sn=e84c3ca0835e3fc749d1510dc55c8400&chksm=882e39f6bf59b0e03d2f1e96abaa4deb7691c4870e985fcab728dc5376c368b26da61fba0e19&token=557267957&lang=zh_CN#rd",
          text: "35岁+程序员=被边缘和淘汰？",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650625536&idx=1&sn=40f0e79d6483cb58895101fffb9607df&chksm=882e364dbf59bf5b307a822e08a68b5c1af6cdcf809dc00241ca9526ac0200c72f4ce82abdc2&token=557267957&lang=zh_CN#rd",
          text: "来自千里之外的感谢",
        },
        {
          url: "https://mp.weixin.qq.com/s?__biz=MzA4ODU5NDcyMg==&mid=2650625489&idx=1&sn=99a1db05795ad1e11c9092e1a6fae7ac&chksm=882e359cbf59bc8a898ff5bc5a49106a8bcacfe5a13b4a52e7210e8fce2dc41f0c5e8a0c4e8b&token=557267957&lang=zh_CN#rd",
          text: "文华老对儿，能处！",
        },
      ],
    };
  },
};
</script>

<style scoped>
.page-wrap {
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.experience {
  flex: auto;
  padding: 0 2.86rem 0 0.54rem;
}

.experience-title {
  margin: 1.86rem 0 1.72rem 0;
  height: 1rem;
  width: 4.156rem;
  /* background: url(../../assets/img/home/gzty.png) no-repeat center/cover; */
  /* image-rendering: pixelated; */
  transform: translateZ(0px);
  -webkit-transform: translateZ(0px);
}

.experience-content {
  position: relative;
  color: #656565;
  font-size: 0.65rem;
  width: 100%;
}

.experience-list .experience-item {
  height: 1.334rem;
  border-bottom: 1px #ababab dashed;
  line-height: 1.334rem;
}

.experience-list .experience-item:last-child {
  border-bottom: none;
}

.experience-list .experience-item a:link,
.experience-list .experience-item a:hover,
.experience-list .experience-item a:visited {
  color: #545454;
  text-decoration: none;
}

.experience-bg {
  height: 4.58rem;
  width: 100%;
  /* background: url(../../assets/img/home/gzjy1.jpg) no-repeat center/cover; */
  /* image-rendering: pixelated; */
  transform: translateZ(0px);
  -webkit-transform: translateZ(0px);
}
</style>